<template>
  <div id="subOrgIdInjector"></div>
</template>

<script>
import EventBusMixin from '@/mixins/EventBusMixin'
import * as R from 'ramda'
import store, { USER_STATUS } from '@/store/store'
import { ROUTE_NAMES } from '@/constants/routes'

/**
 * This component handles routes that do not contain subOrgId. Upon receiving a url of pattern - orgs/${orgId}/*, it converts the url to orgs/${orgId}/suborgs/${rootTeamId(orgId)}/*
 */
export default {
  name: 'SubOrgIdInjector',
  mixins: [EventBusMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (store.state.status === USER_STATUS.LOGGED_IN) {
        vm.handleNavigation()
      } else {
        const unsubscribe = store.subscribe(mutation => {
          if (mutation.type === 'SET_CURRENT_USER') {
            unsubscribe()
            vm.handleNavigation()
          }
        })
      }
    })
  },
  methods: {
    handleNavigation() {
      const { orgId, pathMatch } = this.$route.params
      const rootTeamId = this.$store.getters.rootTeamByOrgId(orgId)?.id
      let location = `/orgs/${orgId}/suborgs/${rootTeamId}/${pathMatch}`
      const matchedRoute = this.$router.match(location)
      if (!R.isEmpty(this.$route.query)) {
        const query = new URLSearchParams(this.$route.query)
        location += `?${query.toString()}`
      }
      if (!rootTeamId || matchedRoute.name === ROUTE_NAMES.ORG_OLD_ROUTE) {
        // 404
        this.eventBusEmit('SHOW_404')
      } else {
        this.$router.replace(location)
      }
    }
  }
}
</script>
